import { queryKeys } from './useQueryPurchasedTemplates'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { useFetchPurchasedTemplates } from './useFetchPurchasedTemplates'
import { queryKeys as licenseQueryKeys } from '../license/useQueryLicense'

const purchase = () => {
  const { purchase } = useFetchPurchasedTemplates()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: purchase,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([queryKeys.all(variables).queryKey])
    },
  })
}

const drop = () => {
  const { drop } = useFetchPurchasedTemplates()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: drop,
    onMutate: (variables) => {
      cancelQueries([queryKeys.all(variables).queryKey])
    },
    onSettled: (_, _1, variables) => {
      invalidateQueries([
        queryKeys.all(variables).queryKey,
        licenseQueryKeys.all._def,
      ])
    },
  })
}

export const useMutationPurchasedTemplates = {
  purchase,
  drop,
}
